import { Link } from "react-router-dom";
import { Mail, MessageCircle, Phone } from "lucide-react";
import PaymentBadges from "@/components/PaymentBadges";
import { useSupportContacts } from "@/hooks/useCatalog";

const COLUMNS = [
  {
    title: "ISMO-TECH",
    links: [
      { label: "À propos", to: "/support#apropos" },
      { label: "Contact", to: "/support" },
      { label: "Nos services", to: "/services" },
      { label: "Déblocage & Services", to: "/deblocage" },
    ],
  },
  {
    title: "Boutique",
    links: [
      { label: "Windows", to: "/boutique?categorie=windows" },
      { label: "Microsoft Office", to: "/boutique?categorie=microsoft-office" },
      { label: "Antivirus", to: "/boutique?categorie=antivirus" },
      { label: "Adobe", to: "/boutique?categorie=adobe" },
      { label: "Outils", to: "/boutique?categorie=outils" },
      { label: "Promotions", to: "/promotions" },
    ],
  },
  {
    title: "Informations",
    links: [
      { label: "Conditions générales", to: "/support#cgv" },
      { label: "Politique de confidentialité", to: "/support#confidentialite" },
      { label: "Politique de remboursement", to: "/support#remboursement" },
      { label: "Livraison numérique", to: "/support#livraison" },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "FAQ", to: "/support#faq" },
      { label: "Ouvrir un ticket", to: "/support#ticket" },
      { label: "Mes commandes", to: "/compte/commandes" },
      { label: "Mes licences", to: "/compte/licences" },
    ],
  },
];

export function Footer() {
  const { data: contacts } = useSupportContacts();

  return (
    <footer className="mt-20 bg-night text-slate-300">
      <div className="container-it py-14">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_repeat(4,1fr)]">
          <div>
            <div className="flex items-center gap-3" data-testid="footer-logo">
              <img src="/logo-footer.png" alt="ISMO-TECH" width="78" height="57" className="h-14 w-auto" />
              <span className="flex flex-col leading-none">
                <span className="font-display text-xl font-extrabold text-white">
                  ISMO<span className="text-brand">-TECH</span>
                </span>
                <span className="mt-1 text-[9px] font-bold uppercase tracking-[0.22em] text-slate-500">
                  Multiples Services Informatiques
                </span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
              Vos licences officielles au meilleur prix. Logiciels, abonnements, outils professionnels et services
              informatiques autorisés — livrés en quelques minutes.
            </p>
            <div className="mt-5 flex flex-col gap-2 text-sm">
              <a
                href={`https://wa.me/${(contacts?.whatsapp || "").replace(/[^0-9]/g, "")}`}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                className="flex items-center gap-2 text-slate-300 transition-colors duration-200 hover:text-brand"
              >
                <MessageCircle className="h-4 w-4" /> WhatsApp
              </a>
              <a
                href={`mailto:${contacts?.email || "Cismo267@gmail.com"}`}
                data-testid="footer-email"
                className="flex items-center gap-2 text-slate-300 transition-colors duration-200 hover:text-brand"
              >
                <Mail className="h-4 w-4" /> {contacts?.email || "Cismo267@gmail.com"}
              </a>
              <span className="flex items-center gap-2 text-slate-400">
                <Phone className="h-4 w-4" /> {contacts?.hours || "7j/7 — 08h à 22h"}
              </span>
            </div>
          </div>

          {COLUMNS.map((column) => (
            <div key={column.title}>
              <h4 className="mb-4 text-sm font-bold uppercase tracking-wider text-white">{column.title}</h4>
              <ul className="space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                      className="text-sm text-slate-400 transition-colors duration-200 hover:text-brand"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 border-t border-white/10 pt-8">
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Moyens de paiement</p>
          <PaymentBadges size="sm" />
          <p className="mt-4 text-xs text-slate-500">
            Paiement sécurisé : Orange Money, Wave, Moov Money, MTN Mobile Money et carte bancaire.
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-it flex flex-col items-center justify-between gap-2 py-5 text-xs text-slate-500 sm:flex-row">
          <p>© 2026 ISMO-TECH — Tous droits réservés. <span data-testid="site-version">V0.1</span></p>
          <p>Licences vérifiées · Livraison instantanée · Support 7j/7</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
